import { API_URL_BASE, DEFAULT_ENV } from '../constants';

const env = process.env.REACT_APP_ENV ?? DEFAULT_ENV;

console.log(env);

// Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// const firebaseConfig = {
//   apiKey: "AIzaSyC3KbLZFY8O_XbEfQue4rJr_cQDaONlrUk",
//   authDomain: "mnc-cloud-ae72a.firebaseapp.com",
//   projectId: "mnc-cloud-ae72a",
//   storageBucket: "mnc-cloud-ae72a.appspot.com",
//   messagingSenderId: "996387459722",
//   appId: "1:996387459722:web:e470a5da7b6c098efb5373"
// };

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);

export const getConfig = (key) => {
  const base = {
    ENV: 'development',
    APP_NAME: 'mnc-cloud-ae72a',
    LOCAL_API_URL:
      'http://localhost:5001/mnc-cloud-ae72a/us-central1/api_dev',
    FIREBASE_CONFIG: {
      apiKey: "AIzaSyC3KbLZFY8O_XbEfQue4rJr_cQDaONlrUk",
      authDomain: "mnc-cloud-ae72a.firebaseapp.com",
      projectId: "mnc-cloud-ae72a",
      storageBucket: "mnc-cloud-ae72a.appspot.com",
      messagingSenderId: "996387459722",
      appId: "1:996387459722:web:e470a5da7b6c098efb5373"
    },
    WHOLESALE_COLLECTION: 'wholesaleRequestsqa',
  };

  const development = {
    ...base,
  };

  const feature = {
    ...development,
    LOCAL_API_URL: `${API_URL_BASE}/api_feature`,
  };

  const qa = {
    ...development,
    LOCAL_API_URL: `${API_URL_BASE}/api_qa`,
  };

  const staging = {
    ...qa,
    ENV: 'staging',
    LOCAL_API_URL: `${API_URL_BASE}/api_staging`,
  };

  const production = {
    ...qa,
    ENV: 'production',
    LOCAL_API_URL: `${API_URL_BASE}/api_prod`,
    WHOLESALE_COLLECTION: 'wholesaleRequests',
  };

  const configSettings = {
    development,
    feature,
    qa,
    staging,
    production,
  };

  return configSettings[env][key] ?? configSettings[env];
};

const conf = {
  getConfig,
};

export default conf;
